import { Box, Divider, FormControl, Heading, Stack } from '@chakra-ui/react';
import { Controller, useFormContext } from 'react-hook-form';

import { SearchableTagsSelect } from '@/components/SearchableTagsSelect';
import { useDraftAnnouncementOptions } from '@/hooks/useDraftAnnouncementOptions';
import { usePostFieldOptions } from '@/hooks/usePostFieldOptions';

import { AnnouncementCheckbox } from '../AnnouncementCheckbox';
import { GroupSelector } from '../GroupSelector';
import { SponsoredPostSelector } from '../SponsoredPostSelector';

export const PostSettings: React.FC<{
  isEditing: boolean;
  isPublished?: boolean;
  /** The original `groupId` of a post that is being edited */
  initialGroupId?: string;
  organizationId?: string;
}> = (props) => {
  const { watch } = useFormContext();
  const groupId = watch('group');

  const { showAnnouncementOption } = useDraftAnnouncementOptions({
    isEditing: props.isEditing,
    isPublished: !!props.isPublished,
    groupId,
  });
  const { showSponsoredPostOption, showGroupsSelector, showTagsSelector } =
    usePostFieldOptions({
      organizationId: props.organizationId,
      editing: props.isEditing,
    });

  if (
    !showGroupsSelector &&
    !showTagsSelector &&
    !showSponsoredPostOption &&
    !showAnnouncementOption
  ) {
    return null;
  }

  return (
    <Stack spacing="2">
      <Divider mb="2" />
      <Heading as="h6" size="xs">
        Settings
      </Heading>
      <Stack spacing="4">
        {showGroupsSelector && (
          <GroupSelector
            isDisabled={!!props.initialGroupId && !props.isEditing}
          />
        )}
        {showTagsSelector && (
          <FormControl>
            <Controller
              name="tags"
              render={({ field: { onChange, onBlur, value, ref } }) => (
                <SearchableTagsSelect
                  value={value}
                  onChange={onChange}
                  onBlur={onBlur}
                  ref={ref}
                />
              )}
            />
          </FormControl>
        )}
        {showSponsoredPostOption && props.organizationId && (
          <SponsoredPostSelector organizationId={props.organizationId} />
        )}
        {showAnnouncementOption && (
          <Box>
            <AnnouncementCheckbox />
          </Box>
        )}
      </Stack>
    </Stack>
  );
};
